import { useEffect, useState } from 'react';
import { isMobile } from '@adecco/base-app/src/constants/breakpoints/breakpoints';

export const useisMobile = () => {
  const [isMobileScreen, setIsMobileScreen] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      const isMobileScreen = isMobile();
      setIsMobileScreen(isMobileScreen);
    };

    handleResize();

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return { isMobileScreen };
};
